import {AxiosRequestConfig, AxiosResponse} from "axios";
import {ApiClient} from "@api/ApiClient";
import {createApiErrorException} from "@api/ApiUtils";

type GetRequestOverload = {
    <TResponse>(url: string, config?: AxiosRequestConfig): Promise<TResponse>;
    <TResponse>(url: string, config?: AxiosRequestConfig, returnFullResponse?: boolean): Promise<AxiosResponse<TResponse>>;
}

export const getRequest: GetRequestOverload = async <TResponse>(url: string, config?: AxiosRequestConfig, returnFullResponse?: boolean) => {

    try {

        const apiResponse = await ApiClient.get<TResponse>(url, config);

        if (typeof returnFullResponse === 'boolean' && returnFullResponse) {

            return apiResponse as AxiosResponse<TResponse>;
        }

        return apiResponse.data as TResponse;

    } catch (ex) {
        throw createApiErrorException(ex);
    }
}

export const postRequest = async <TResponse, TPayload = any>(url: string, payload?: TPayload, config?: AxiosRequestConfig): Promise<TResponse> => {

    try {
        const apiResponse = await ApiClient.post<TResponse, AxiosResponse<TResponse>, TPayload>(url, payload, config);
        return apiResponse.data;
    } catch (ex) {
        throw createApiErrorException(ex);
    }

}

export const putRequest = async <TResponse, TPayload = any>(url: string, payload?: TPayload, config?: AxiosRequestConfig): Promise<TResponse> => {

    try {
        const apiResponse = await ApiClient.put<TResponse, AxiosResponse<TResponse>, TPayload>(url, payload, config);
        return apiResponse.data;
    } catch (ex) {
        throw createApiErrorException(ex);
    }

}

export const patchRequest = async <TResponse, TPayload>(url: string, payload?: TPayload, config?: AxiosRequestConfig): Promise<TResponse> => {

    try {
        const apiResponse = await ApiClient.patch<TResponse, AxiosResponse<TResponse>, TPayload>(url, payload, config);
        return apiResponse.data;
    } catch (ex) {
        throw createApiErrorException(ex);
    }

}

export const deleteRequest = async <TResponse>(url: string, config?: AxiosRequestConfig): Promise<TResponse> => {

    try {
        const apiResponse = await ApiClient.delete<TResponse, AxiosResponse<TResponse>>(url, config);
        return apiResponse.data;
    } catch (ex) {
        throw createApiErrorException(ex);
    }

}
